const titleCase = (name: string) => name.charAt(0).toUpperCase() + name.slice(1)

export default titleCase
